export default "__VITE_ASSET__Bhm5WOL4__"